"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWhyDidYouUpdate = void 0;
const react_1 = require("react");
function useWhyDidYouUpdate(name, props) {
    const previousProps = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (previousProps.current) {
            const allKeys = Object.keys(Object.assign(Object.assign({}, previousProps.current), props));
            const changesObj = {};
            allKeys.forEach((key) => {
                if (previousProps.current[key] !== props[key]) {
                    changesObj[key] = {
                        from: previousProps.current[key],
                        to: props[key],
                    };
                }
            });
            if (Object.keys(changesObj).length) {
                console.log("[why-did-you-update]", name, changesObj);
            }
        }
        previousProps.current = props;
    });
}
exports.useWhyDidYouUpdate = useWhyDidYouUpdate;
//# sourceMappingURL=useWhyDidYouUpdate.js.map